import { useEffect } from 'react'
import { trackInternalEvent } from '@rio/tracking'

import { useI18n } from 'builder/hooks/useI18n'
import { useMediaQueries } from 'builder/hooks/useMediaQueries'
import { BannerInfo } from '../Banners/BannerInfo/BannerInfo'
import { CareerSteps } from '../Banners/CareerSteps/CareerSteps'

import { TRANSLATION } from './constants'
import * as Styles from './styles'
import coachImage from './assets/image.png'
import coachImageMobile from './assets/image-mobile.png'

export const ResumeWritingBanner = () => {
  const { i18n } = useI18n()
  const { isPhone } = useMediaQueries()

  const bannerItems = [
    i18n.t(`${TRANSLATION}.banner.one`),
    i18n.t(`${TRANSLATION}.banner.two`),
    i18n.t(`${TRANSLATION}.banner.three`),
  ]

  const careerSteps = [
    {
      number: 1,
      title: i18n.t(`${TRANSLATION}.steps.step_1.title`),
      desc: i18n.t(`${TRANSLATION}.steps.step_1.description`),
    },
    {
      number: 2,
      title: i18n.t(`${TRANSLATION}.steps.step_2.title`),
      desc: i18n.t(`${TRANSLATION}.steps.step_2.description`),
    },
    {
      number: 3,
      title: i18n.t(`${TRANSLATION}.steps.step_3.title`),
      desc: i18n.t(`${TRANSLATION}.steps.step_3.description`),
    },
    {
      number: 4,
      title: i18n.t(`${TRANSLATION}.steps.step_4.title`),
      desc: i18n.t(`${TRANSLATION}.steps.step_4.description`),
    },
  ]

  useEffect(() => {
    trackInternalEvent('see_rw_promo')
  }, [])

  return (
    <Styles.Container>
      <Styles.BannerContainer>
        <BannerInfo theme="resume_writing" items={bannerItems} />
      </Styles.BannerContainer>
      <Styles.InfoContainer>
        <Styles.Title>{i18n.t(`${TRANSLATION}.header`)}</Styles.Title>
        <Styles.Description
          dangerouslySetInnerHTML={{ __html: i18n.t(`${TRANSLATION}.sub_header`) }}
        />
      </Styles.InfoContainer>
      <Styles.ImageContainer>
        <Styles.Image src={isPhone ? coachImageMobile : coachImage} alt="Resume writing image" />
      </Styles.ImageContainer>
      <CareerSteps steps={careerSteps} />
    </Styles.Container>
  )
}
